import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, combineLatest, takeUntil, map } from 'rxjs';
import defautlConfig from 'config/default.json';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})

export class ApiServiceModule { 
  
  constructor(private http: HttpClient) {
  }
  private getAuthHeaders(token:string): HttpHeaders {
    return new HttpHeaders({
      'Authorization': `Bearer ${token || ''}`
    });
  }

  queryData(url:string, formData:object, token:string): Observable<any[]> {
    return this.http.post<any[]>(url, formData,  {headers: this.getAuthHeaders(token)})
  }

  queryFile(url:string, formData:object, token:string): Observable<Blob> {
    return this.http.post(url, formData, {responseType: "blob", headers: this.getAuthHeaders(token)});
  }
  queryFileAndData(url:string, formData:object, token:string) : any{
    return this.http.post(url, formData, { responseType: 'blob', observe: 'response', headers: this.getAuthHeaders(token)});
  }
  uploadDataAndFile(url:string, formData:object, token:string):  Observable<any[]> {
    return this.http.post<any[]>(url, formData, {headers: this.getAuthHeaders(token)})
  }
}